module.exports = __webpack_public_path__ + "static/0061-da1c2e5af3c43ddc0ed937ef1f090eab.png";